import { useState, useCallback } from 'react';
import { UserCheck, RotateCcw } from 'lucide-react';
import { useTheme } from '../../contexts/ThemeContext';
import { cn } from '../../lib/utils';
import Dropdown from '../ui/Dropdown';

export default function ActAsSelector() {
  const { theme, availableUsers, actAsUser, setActAsUser } = useTheme();
  const [isOpen, setIsOpen] = useState(false);
  const onClose = useCallback(() => setIsOpen(false), []);

  return (
    <Dropdown
      isOpen={isOpen}
      onClose={onClose}
      width="w-64"
      trigger={
        <button
          onClick={() => setIsOpen(!isOpen)}
          className={cn(
            'flex items-center gap-1.5 px-3 py-2 rounded-lg text-sm font-medium transition-all',
            actAsUser
              ? 'bg-purple-600 text-white border border-purple-500'
              : theme.headerBackground
                ? 'text-black/70 hover:text-black hover:bg-black/10'
                : 'text-white/70 hover:text-white hover:bg-white/10',
          )}
          title="Act As another user (Super Admin only)"
        >
          <UserCheck className="w-4 h-4" />
          <span className="hidden sm:inline">
            {actAsUser ? actAsUser.name : 'Act As'}
          </span>
        </button>
      }
    >
      <div className="p-2 border-b border-border">
        <p className="text-xs text-muted-foreground px-2 py-1">Act As User</p>
      </div>
      <div className="p-2 space-y-1 max-h-64 overflow-y-auto">
        {availableUsers.map((u) => (
          <button
            key={u.email}
            onClick={() => {
              setActAsUser(u);
              setIsOpen(false);
            }}
            className={cn(
              'w-full flex items-center gap-2 px-3 py-2 text-sm rounded-lg transition-colors text-left',
              actAsUser?.email === u.email
                ? 'bg-purple-600/20 text-purple-400'
                : 'text-muted-foreground hover:text-foreground hover:bg-background',
            )}
          >
            <div className="w-6 h-6 rounded-full bg-purple-600/30 flex items-center justify-center text-xs font-medium text-purple-300">
              {u.name[0]?.toUpperCase() || '?'}
            </div>
            <div className="flex-1 min-w-0">
              <div className="font-medium truncate">{u.name}</div>
              <div className="text-xs opacity-60 truncate">{u.email}</div>
            </div>
          </button>
        ))}
        {availableUsers.length === 0 && (
          <p className="text-sm text-muted-foreground px-3 py-2">No users available</p>
        )}
        {actAsUser && (
          <>
            <div className="border-t border-border my-1" />
            <button
              onClick={() => {
                setActAsUser(null);
                setIsOpen(false);
              }}
              className="w-full flex items-center gap-2 px-3 py-2 text-sm text-purple-400 hover:bg-purple-500/10 rounded-lg transition-colors"
            >
              <RotateCcw className="w-4 h-4" />
              Stop impersonating
            </button>
          </>
        )}
      </div>
    </Dropdown>
  );
}
